import { Vector3 } from 'three';

export const getProjectedQuaternion = (pos: Vector3, target: Vector3, axisVec: Vector3, THREE) => {
  const dir = new THREE.Vector3();
  dir.subVectors(target, pos).normalize();
  dir.projectOnPlane(axisVec);
  const mx = new THREE.Matrix4().lookAt(
    dir,
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0, 1, 0),
  );
  return new THREE.Quaternion().setFromRotationMatrix(mx);
};
